import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Services() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-500 to-pink-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Services</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Comprehensive creative and educational solutions tailored to your needs
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* Art Commissions */}
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-brush-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Art Commissions</h3>
                  <p className="text-gray-700">Custom artwork created specifically for you</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Personalized art pieces tailored to your vision and preferences</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Collaborative process from concept to completion</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Various styles and mediums available</span>
                </li>
              </ul>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Request Commission
              </Link>
            </div>

            {/* Portrait Drawing */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-user-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Portrait Drawing</h3>
                  <p className="text-gray-700">Lifelike pencil portraits that capture essence</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Hyperrealistic pencil and charcoal portraits</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Individual, couple, family, and pet portraits</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Perfect for gifts and special occasions</span>
                </li>
              </ul>
              <Link to="/art-paintings" className="whitespace-nowrap inline-block bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                View Gallery
              </Link>
            </div>

            {/* Painting */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-palette-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Canvas Painting</h3>
                  <p className="text-gray-700">Original paintings in various styles</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Acrylic, oil, and watercolor paintings</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Abstract, realistic, and contemporary styles</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-purple-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Custom sizes and color schemes</span>
                </li>
              </ul>
              <Link to="/art-paintings" className="whitespace-nowrap inline-block bg-purple-500 hover:bg-purple-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Explore Paintings
              </Link>
            </div>

            {/* Wall Murals */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-home-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Wall Murals</h3>
                  <p className="text-gray-700">Transform spaces with stunning murals</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Indoor and outdoor mural painting</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Residential, commercial, and institutional spaces</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Custom designs that match your space</span>
                </li>
              </ul>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Get Quote
              </Link>
            </div>

            {/* Digital Painting */}
            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-computer-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Digital Painting</h3>
                  <p className="text-gray-700">Modern digital art and illustrations</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Digital illustrations for various purposes</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Character design and concept art</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">High-resolution files for print and digital use</span>
                </li>
              </ul>
              <Link to="/art-paintings" className="whitespace-nowrap inline-block bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                See Examples
              </Link>
            </div>

            {/* Graphic Design */}
            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-layout-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Graphic Design</h3>
                  <p className="text-gray-700">Professional designs for all your needs</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-pink-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Posters, flyers, and brochures</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-pink-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Social media graphics and content</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-pink-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Business cards, banners, and promotional materials</span>
                </li>
              </ul>
              <Link to="/graphic-design" className="whitespace-nowrap inline-block bg-pink-500 hover:bg-pink-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                View Designs
              </Link>
            </div>

            {/* Brand Identity */}
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-indigo-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-star-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Brand Identity Support</h3>
                  <p className="text-gray-700">Build a memorable brand presence</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Logo design and brand guidelines</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Consistent visual identity across platforms</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-indigo-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Brand strategy and positioning</span>
                </li>
              </ul>
              <Link to="/contact" className="whitespace-nowrap inline-block bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Start Branding
              </Link>
            </div>

            {/* Educational Content */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-book-open-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Educational Content Creation</h3>
                  <p className="text-gray-700">Quality teaching materials for educators</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Lesson notes for Cultural and Creative Arts</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Test questions and examination papers</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Scheme of work preparation</span>
                </li>
              </ul>
              <Link to="/education" className="whitespace-nowrap inline-block bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Learn More
              </Link>
            </div>

            {/* Storytelling Content */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-video-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">Storytelling Content Creation</h3>
                  <p className="text-gray-700">Engaging stories that captivate audiences</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Artful Tales with Tennyson bedtime stories</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">YouTube content creation and editing</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Creative storytelling for various platforms</span>
                </li>
              </ul>
              <Link to="/storytelling" className="whitespace-nowrap inline-block bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Watch Stories
              </Link>
            </div>

          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Our Process</h2>
            <p className="text-xl text-gray-600">Simple, transparent, and collaborative</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white text-2xl font-bold">
                1
              </div>
              <h4 className="text-xl font-bold mb-2">Consultation</h4>
              <p className="text-gray-600">We discuss your vision, requirements, and expectations</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white text-2xl font-bold">
                2
              </div>
              <h4 className="text-xl font-bold mb-2">Planning</h4>
              <p className="text-gray-600">We create a detailed plan and timeline for your project</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white text-2xl font-bold">
                3
              </div>
              <h4 className="text-xl font-bold mb-2">Creation</h4>
              <p className="text-gray-600">We bring your vision to life with skill and creativity</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white text-2xl font-bold">
                4
              </div>
              <h4 className="text-xl font-bold mb-2">Delivery</h4>
              <p className="text-gray-600">We deliver your completed project on time</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-blue-600">
        <div className="container mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's discuss your project and create something amazing together
          </p>
          <Link 
            to="/contact" 
            className="whitespace-nowrap inline-block bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
          >
            Contact Us Today
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}